import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSubscription } from '../hooks/useSubscription';

const SubscriptionSuccessPage = () => {
	const navigate = useNavigate();
	const { refreshSubscription } = useSubscription();
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		// Refresh subscription data after successful payment
		// Only run once on mount to avoid infinite loops
		const refreshData = async () => {
			try {
				// Wait longer for webhook to process (especially for upgrades/downgrades)
				await new Promise(resolve => setTimeout(resolve, 3000));
				await refreshSubscription();
				
				// Try again after another delay to ensure webhook completed
				await new Promise(resolve => setTimeout(resolve, 2000));
				await refreshSubscription();
			} catch (error) {
				console.error('Error refreshing subscription:', error);
			} finally {
				setIsLoading(false);
			}
		};

		refreshData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []); // Empty deps - only run once on mount

	const handleGoToDashboard = () => {
		navigate('/dashboard');
	};

	const handleGoToSubscription = () => {
		navigate('/subscription');
	};

	return (
		<div className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
			<div className="w-full max-w-md rounded-lg bg-white p-8 shadow-lg">
				{isLoading ? (
					<div className="text-center">
						<div className="mb-4 inline-block h-12 w-12 animate-spin rounded-full border-4 border-blue-600 border-t-transparent"></div>
						<p className="text-gray-600">Processing your subscription...</p>
					</div>
				) : (
					<>
						{/* Success Icon */}
						<div className="mb-4 flex justify-center">
							<div className="flex h-16 w-16 items-center justify-center rounded-full bg-green-100">
								<svg
									className="h-8 w-8 text-green-600"
									fill="none"
									stroke="currentColor"
									viewBox="0 0 24 24"
								>
									<path
										strokeLinecap="round"
										strokeLinejoin="round"
										strokeWidth={2}
										d="M5 13l4 4L19 7"
									/>
								</svg>
							</div>
						</div>

					{/* Success Message */}
					<div className="mb-6 text-center">
						<h1 className="mb-2 text-2xl font-bold text-gray-900">
							Subscription Successful!
						</h1>
						<p className="text-gray-600">
							Your subscription has been activated. You now have access to all
							features in your plan.
						</p>
					</div>

						{/* Action Buttons */}
						<div className="space-y-3">
							<button
								onClick={handleGoToDashboard}
								className="w-full rounded-lg bg-blue-600 px-4 py-2 font-semibold text-white hover:bg-blue-700"
							>
								Go to Dashboard
							</button>
							<button
								onClick={handleGoToSubscription}
								className="w-full rounded-lg border border-gray-300 bg-white px-4 py-2 font-semibold text-gray-700 hover:bg-gray-50"
							>
								View Subscription
							</button>
						</div>
					</>
				)}
			</div>
		</div>
	);
};

export default SubscriptionSuccessPage;

